export const ADWORDS_STRUCTURE_REPORTS = [
  'CAMPAIGN_CRITERIA_REPORT',
  'CAMPAIGN_NEGATIVE_KEYWORDS_PERFORMANCE_REPORT',
  'CAMPAIGN_NEGATIVE_LOCATIONS_REPORT',
  'CAMPAIGN_NEGATIVE_PLACEMENTS_PERFORMANCE_REPORT',
  'LABEL_REPORT',
];
